import React, { useEffect, useState } from 'react';
import ErrorWrapper from '@component/ErrorWrapper';
import { SmartFormStates } from './SmartForm';
import { syncValidatorResults } from "@component/smartForm/validatorUtils"

import {
  Typography,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@mui/material';

function getOptionLabelByValue(options, value) {
  const option = options.find((option) => option.value === value);
  return option ? option.label : value;
}

const SmartRadioInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  renderView,
  options = [],
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  editable = true
}) => {

  const [showError, setShowError] = useState(false)
  const [validatorResult, setValidatorResult] = useState("");

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);


  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label)
      setValidatorResult(validatorResult)
    }

  }, [value, validator, label, setValidatorResults, validatorResults])


  const handleChange = (e) => {
    onChange(field, e.target.value);
  };

  return (
    <Box sx={sx}>
      {!isEdit || !editable ? (
        renderView ? (
          renderView(value)
        ) : (
          <>
            {label && <Typography variant="h6">{label}</Typography>}
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              {getOptionLabelByValue(options, value) || '-'}
            </Typography>
          </>
        )
      ) : (
        <ErrorWrapper message={validatorResult} showMessage={showError}>
          {label && <Typography variant="h6">{label}</Typography>}
          <RadioGroup
            value={value || ''}
            onChange={handleChange}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </ErrorWrapper>

      )}
    </Box>
  );
};

export default SmartRadioInput;